export default __webpack_public_path__ + "static/media/panel2.c09debb7.png";